<template>
    <div :class="['card-container', 'vest', 'no-bg']">
        <div class="exhibit-table">
            <div class="row medium">
                <div class="item">
                    <span>{{ $t('page.apy') }}</span>
                    <p>{{ apy }} %</p>
                </div>
                <div class="item">
                    <span>{{ $t('page.nextEpoch') }}</span>
                    <p>{{ getExpirationDate() }}</p>
                </div>
            </div>
        </div>
        <div class="card-body">
            <div class="hd">
                <div class="title">{{ $t('page.veGYROlist') }}</div>
            </div>
            <div class="bd">
                <div v-loading="fullscreenLoading" class="vest-container">
                    <div v-if="vestData.length > 0" class="vest-list">
                        <el-table :data="vestData" @row-click="showDetail" style="width: 100%">
                            <el-table-column min-width="32%" :label="`${$t('page.tokenId')}\n${$t('page.expirationDate')}`">
                                <template slot-scope="scope">
                                    {{ scope.row.token }}
                                    <br />
                                    <span class="small">{{ formatStr(scope.row.expirationDate) }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column align="right" min-width="44%" :label="`${$t('page.voteValue')}\n${$t('page.voteAmount')}`">
                                <template slot-scope="scope">
                                    {{ scope.row.voteValue }}
                                    <span class="min">veGYRO</span>
                                    <br />
                                    <span class="small">{{ scope.row.voteAmount }} GYRO</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="address" min-width="24%" align="right" :label="$t('page.lockRewards')">
                                <template slot-scope="scope">
                                    {{ scope.row.lockRewards }}
                                    <svg-icon icon-class="icon-sGYRO" />
                                </template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <el-empty v-else :description="$t('page.noData')"></el-empty>
                </div>
                <div class="btns m-top_20">
                    <el-button
                        type="primary"
                        class="btn"
                        @click="
                            currentData = {};
                            visible = true;
                        "
                        round
                    >
                        {{ $t('page.createLock') }}
                    </el-button>
                    <el-button type="primary" :loading="claimLoading" v-if="nftTokens.length > 0" class="btn" @click="claimRewards" round>
                        {{ $t('page.claimVoteRewards') }}
                    </el-button>
                </div>
            </div>
        </div>
        <lockDetail :visible.sync="visible" :lock-data="currentData"></lockDetail>
    </div>
</template>
<script>
import {utils} from 'ethers';
import lockDetail from './lock';
import VeGyroAbi from '@/abis/veGyro';
import veGyroDistAbi from '@/abis/veGyroDist';
import {GYRO_ADDRESSES} from '@/connectors/config';
import {numberDecimals, formatDate} from '@/utils';

export default {
    components: {
        lockDetail
    },
    data() {
        return {
            visible: false,
            isSync: false,
            vestData: [],
            currentData: {},
            fullscreenLoading: true,
            pageLoading: true,
            nftTokens: [],
            claimLoading: false,
            apy: 0
        };
    },
    watch: {
        '$store.state.wallet.blockNumber': {
            immediate: true,
            handler() {
                if (!this.isSync) this.getLockInfo();
            }
        }
    },
    methods: {
        getExpirationDate() {
            const startDate = new Date('2022/3/31');
            startDate.setHours(0 - startDate.getTimezoneOffset() / 60, 0, 0, 0);
            const dayDate = new Date();
            const interval = 1;
            let second = (dayDate.getTime() / 1000 - startDate.getTime() / 1000) % (interval * 86400);
            second = interval * 86400 - parseInt(second);
            const h = Math.floor(second / 3600);
            const m = Math.floor((second / 60) % 60);
            return `${h} ${this.$t('page.hour')}, ${m} ${this.$t('page.minute')}`;
        },
        showDetail(row) {
            this.currentData = row;
            this.visible = true;
        },
        formatStr(date) {
            return formatDate(new Date(date), 'yyyy-MM-dd');
        },
        isExpire(date) {
            return new Date().getTime() <= new Date(date).getTime();
        },
        async claimRewards() {
            const {veGyroDistContract} = this.$store.state.wallet;
            if (!veGyroDistContract) return;
            try {
                this.claimLoading = true;
                // const validVest = this.vestData.filter(vest => vest.expirationDate > new Date().getTime());
                const tokens = this.vestData.map(vest => vest.token);
                const tx = await veGyroDistContract.claim_many(tokens);
                await tx.wait();
                this.claimLoading = false;
                this.$message.success(this.$t('page.exchangeSuccess'));
            } catch (error) {
                this.claimLoading = false;
                this.$message.error((error.data ? error.data.message : error.message) || this.$t('page.exchangeFailed'));
            }
        },
        async getLockInfo() {
            const {veGyroContract, veGyroDistContract, multicall, account, GyroMinterContract} = this.$store.state.wallet;
            if (!veGyroContract || !veGyroDistContract || !account || !multicall || !GyroMinterContract) return;
            try {
                this.isSync = true;

                const daily = await GyroMinterContract.daily();
                const currentRewards = await GyroMinterContract.calculate_growth(daily);
                const veTotal = await veGyroContract.totalSupply();
                const interval = 1;
                const apy =
                    numberDecimals(
                        Math.pow(1 + utils.formatUnits(currentRewards, 9) / utils.formatUnits(veTotal, 9), 365 / interval - 1) - 1,
                        10000
                    ) * 100;
                this.apy =
                    apy > 1000000
                        ? `${(apy / 1000000).toLocaleString('en', {minimumFractionDigits: 2})}M`
                        : apy.toLocaleString('en', {minimumFractionDigits: 2});

                let nftCount = await veGyroContract.balanceOf(account);
                nftCount = utils.formatUnits(nftCount, 0);
                if (nftCount <= 0) {
                    this.isSync = false;
                    this.fullscreenLoading = false;
                    return (this.vestData = []);
                }
                const nftIdData = [];
                for (let index = 0; index < nftCount; index++) {
                    nftIdData.push(veGyroContract.tokenOfOwnerByIndex(account, index));
                }
                const nftIds = await Promise.all(nftIdData);
                const nftData = [];
                this.nftTokens = nftIds;
                nftIds.forEach(id => {
                    const contractCallContext = [
                        {
                            reference: 'veGyroContract',
                            contractAddress: GYRO_ADDRESSES.veGyro,
                            abi: VeGyroAbi,
                            calls: [
                                {reference: 'balanceOfNFTCall', methodName: 'balanceOfNFT', methodParameters: [id]},
                                {reference: 'locked__endCall', methodName: 'locked__end', methodParameters: [id]},
                                {reference: 'lockedCall', methodName: 'locked', methodParameters: [id]}
                            ]
                        }
                    ];
                    nftData.push(multicall.call(contractCallContext));
                });
                const vestData = (await Promise.all(nftData)) || [];
                const vestList = [];
                for (let index = 0; index < vestData.length; index++) {
                    const contractData = vestData[index];
                    const {veGyroContract} = contractData.results;
                    if (!veGyroContract || !veGyroContract.callsReturnContext || veGyroContract.callsReturnContext.length !== 3) return {};
                    const expirationDate = utils.formatUnits(veGyroContract.callsReturnContext[1].returnValues[0], 0);
                    const voteValue = numberDecimals(utils.formatUnits(veGyroContract.callsReturnContext[0].returnValues[0], 9));
                    let lockRewards = 0;
                    if (voteValue != 0) {
                        const res = await veGyroDistContract.claimable(nftIds[index].toString());
                        lockRewards = numberDecimals(utils.formatUnits(res, 9));
                    }
                    vestList.push({
                        voteValue,
                        expirationDate: new Date(expirationDate * 1000).getTime(),
                        voteAmount: numberDecimals(utils.formatUnits(veGyroContract.callsReturnContext[2].returnValues[0], 9)),
                        lockRewards,
                        token: nftIds[index]
                    });
                }
                this.vestData = vestList;
                this.fullscreenLoading = false;
                this.isSync = false;
            } catch (error) {
                this.fullscreenLoading = false;
                this.isSync = false;
                this.$message.error((error.data ? error.data.message : error.message) || this.$t('page.getDateError'));
            }
        }
    }
};
</script>
<style lang="scss" scoped></style>
